export function questionFormatter({item, index}) {
    return `${index + 1}. ${item.question}`;
}